module.exports = __webpack_public_path__ + "media/images/icon_check-86bbe20dc387b72a72f0eefb7785a5d1.png";